import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

type ForgotPasswordRequest = {
  email: string;
};

export type ForgotPasswordResponseDto = {
  messages: string;
  resetCode: string;
};

export type ForgotPasswordParams = RequestConfig<ForgotPasswordRequest>;

export const forgotPassword = async ({
  params,
  config
}: ForgotPasswordParams) =>
  api.post<ForgotPasswordResponseDto>(
    '/api/account/forgotPassword',
    params,
    config
  );
